import { Pipe, PipeTransform } from '@angular/core';
import { ChangeOrder } from '../../domains/change-orders/change-order/change-order.model';
import { totalNormalizedUnits } from './total-normalized-units.pipe';

/** The line's price of the whole units its accepted deductions use up (see totalNormalizedUnits). */
export const totalNormalizedPrice = (changeOrders: ChangeOrder[] | undefined, pricePerUnit: number): number =>
  +(totalNormalizedUnits(changeOrders, pricePerUnit) * pricePerUnit).toFixed(2);

@Pipe({
  name: 'totalNormalizedPrice',
})
export class TotalNormalizedPricePipe implements PipeTransform {
  transform(changeOrders: ChangeOrder[], pricePerUnit: number): number {
    return totalNormalizedPrice(changeOrders, pricePerUnit);
  }
}
